var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0057B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.5,283.5c0-155.9-126.4-282-282-282c-155.9,0-282,126.4-282,282c0,155.9,126.4,282,282,282 S565.5,439.1,565.5,283.5 M60.1,160.6h137.3L84.2,440.7h399.5C437.1,500,364.7,538,283.3,538C142.5,538,28.5,424,28.5,283.3 C28.7,238.9,40,197.1,60.1,160.6 M446.7,282.5V248h-69.1v-87.2h128.8c20.1,36.4,31.4,78.2,31.4,122.8s-11.3,86.4-31.4,122.8h-326 l113.1-280.1H83c46.6-59.3,119-97.3,200.4-97.3c81.2,0,153.7,38,200.4,97.3H301.8v254.8h76v-98.7H446.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZf);
export default __webpack_public_path__ + "static/media/zf.17ec01c25b035fa8be4e6bb455b6db2c.svg";
export { ForwardRef as ReactComponent };